var exports = {
  "tB": "ApplicationDetail.module__page___bm5oR2",
  "Vr": "ApplicationDetail.module__pageHeader___bm5oR2",
  "d1": "ApplicationDetail.module__heroCard___bm5oR2",
  "CI": "ApplicationDetail.module__heroTop___bm5oR2",
  "ZY": "ApplicationDetail.module__heroTitle___bm5oR2",
  "Uz": "ApplicationDetail.module__metaInput___bm5oR2",
  "WA": "ApplicationDetail.module__detailGrid___bm5oR2",
  "fP": "ApplicationDetail.module__columnStack___bm5oR2",
  "E7": "ApplicationDetail.module__sectionSpacer___bm5oR2",
  "Nr": "ApplicationDetail.module__card___bm5oR2",
  "Wg": "ApplicationDetail.module__cardDanger___bm5oR2",
  "MY": "ApplicationDetail.module__cardHeader___bm5oR2",
  "JJ": "ApplicationDetail.module__cardTitle___bm5oR2",
  "Dc": "ApplicationDetail.module__cardSubtitle___bm5oR2",
  "eB": "ApplicationDetail.module__cardActions___bm5oR2",
  "zI": "ApplicationDetail.module__cardBody___bm5oR2",
  "tx": "ApplicationDetail.module__secretRow___bm5oR2",
  "cD": "ApplicationDetail.module__secretActions___bm5oR2",
  "PZ": "ApplicationDetail.module__fieldStack___bm5oR2",
  "rP": "ApplicationDetail.module__redirectList___bm5oR2",
  "bs": "ApplicationDetail.module__redirectRow___bm5oR2",
  "C2": "ApplicationDetail.module__redirectActions___bm5oR2",
  "py": "ApplicationDetail.module__redirectRemoveButton___bm5oR2",
  "t_": "ApplicationDetail.module__createRedirectButton___bm5oR2",
  "PM": "ApplicationDetail.module__scopeGrid___bm5oR2",
  "bk": "ApplicationDetail.module__fieldLabel___bm5oR2",
  "Jb": "ApplicationDetail.module__scopeList___bm5oR2",
  "LR": "ApplicationDetail.module__botPermissionList___bm5oR2",
  "_": "ApplicationDetail.module__scopeItem___bm5oR2",
  "$o": "ApplicationDetail.module__scopeLabel___bm5oR2",
  "Ud": "ApplicationDetail.module__avatarRow___bm5oR2",
  "_Q": "ApplicationDetail.module__avatarPreview___bm5oR2",
  "rZ": "ApplicationDetail.module__avatarPlaceholder___bm5oR2",
  "Jm": "ApplicationDetail.module__tagRow___bm5oR2",
  "vb": "ApplicationDetail.module__discriminatorInput___bm5oR2",
  "jY": "ApplicationDetail.module__validationBox___bm5oR2",
  "JE": "ApplicationDetail.module__bannerRow___bm5oR2",
  "HF": "ApplicationDetail.module__builderResult___bm5oR2",
  "Ml": "ApplicationDetail.module__loadingState___bm5oR2",
  "cy": "ApplicationDetail.module__helperText___bm5oR2",
  "RJ": "ApplicationDetail.module__dangerContent___bm5oR2",
  "n7": "ApplicationDetail.module__dangerActions___bm5oR2",
  "z3": "ApplicationDetail.module__error___bm5oR2",
  "sM": "ApplicationDetail.module__srOnly___bm5oR2",
};

module.exports = exports;
